import { ReactComponent as Mail } from "assets/icons/contacts/Letter.svg";
import { ReactComponent as Discord } from "assets/icons/contacts/discord.svg";
import { ReactComponent as Instagram } from "assets/icons/contacts/instagram.svg";
import { ReactComponent as X } from "assets/icons/contacts/X.svg";
import { ReactComponent as Facebook } from "assets/icons/contacts/facebook.svg";
import { ReactComponent as PinMap } from 'assets/icons/contacts/map-pin.svg'

import { Link } from "react-router-dom";


const ContactsInfo = ({
    support_title,
    support_email,
    support_discord_text,
    support_discord_link,
    office_title,
    office_address,
    social_title,
    social_instagram,
    social_x,
    social_facebook,
}) => {



    return (
        <div className="contacts-info">
            <div className="body1 contacts-info-section">
                <div className="contacts-info-title">{support_title}</div>
                <Link to={`mailto:${support_email}`} className="contacts-info-item contacts-info-item--hover">
                    <div className="contacts-info-item-icon"><Mail /></div>
                    <div className="body2 contacts-info-item-name">{support_email}</div>
                </Link>
                <Link to={support_discord_link} aria-label='Support in Discord' className="contacts-info-item  contacts-info-item--hover">
                    <div className="contacts-info-item-icon"><Discord /></div>
                    <div className="body2 contacts-info-item-name">{support_discord_text}</div>
                </Link>
            </div>
            <div className="contacts-info-section">
                <div className="body1 contacts-info-title">{office_title}</div>
                <div className="contacts-info-item">
                    <div className="contacts-info-item-icon"><PinMap /></div>
                    <div className="body2 contacts-info-item-name">{office_address}</div>
                </div>

            </div>
            <div className="contacts-info-section">
                <div className="body1 contacts-info-title">{social_title}</div>
                <div className="contacts-info-socials">
                    <Link to={social_instagram} aria-label="We're in Instagram" className="contacts-info-item">
                        <div className="contacts-info-item-icon"><Instagram /></div>
                    </Link>
                    <Link to={social_x} aria-label="We're in Twitter" className="contacts-info-item">
                        <div className="contacts-info-item-icon"><X /></div>
                    </Link>
                    <Link to={social_facebook} aria-label="We're in Facebook" className="contacts-info-item">
                        <div className="contacts-info-item-icon"><Facebook /></div>
                    </Link>
                </div>
            </div>

        </div>
    );
}

export default ContactsInfo;